import { render, staticRenderFns } from "./VineyardsModuleComponent.vue?vue&type=template&id=3392a292&scoped=true"
import script from "./VineyardsModuleComponent.vue?vue&type=script&lang=js"
export * from "./VineyardsModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./VineyardsModuleComponent.vue?vue&type=style&index=0&id=3392a292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3392a292",
  null
  
)

export default component.exports